import Modal from './modal/modalComponent';
import { useGetGenericActions } from '../hooks/useGetGenericActions';
import { genericActionsIds, pageIds } from '../utilities/constants';
import { ModalButtonProps } from './modal/modal.interfaces';
import { useNavigate } from 'react-router-dom';
import { useGetConversation } from '../app/messages/hooks/useGetConversation';
import { useGetPage } from '../hooks/useGetPage';
import Loader from './loaderComponent';
import React from 'react';
import { GroupByDayMessages } from '../app/messages/components/InMailConversation';
import { interpolateVariables } from '../utilities/functions';

export const PatientChatModal = () => {
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const inMailId = searchParams.get('inMailId');

  const { data: locale } = useGetPage({
    locale: 'en',
    pageId: pageIds.MESSAGES,
  });

  const { data: genericAction, loading: genericActionLoading } =
    useGetGenericActions({
      locale: 'en',
      genericActionId: [
        genericActionsIds.CANCEL,
        genericActionsIds.EDIT,
        genericActionsIds.CLOSE,
        genericActionsIds.SAVE,
      ],
    });

  const onClose = () => {
    navigate(-1);
  };

  const Buttons: ModalButtonProps[] = [
    {
      label: genericAction?.[genericActionsIds.CLOSE]?.close,
      onClick: onClose,
      containerClassName: 'font-bold',
      className: '!text-sm',
      testID: 'close',
    },
  ];

  const { loading, conversation, messages } = useGetConversation(
    inMailId as string,
  );

  if (!inMailId) return null;

  if (loading || genericActionLoading || !locale) return <Loader />;

  return (
    <Modal
      isOpen={!!inMailId}
      onClose={onClose}
      buttons={Buttons}
      title={interpolateVariables(locale?.patientModalTitle, {
        name: `${conversation?.provider.firstName} ${conversation?.provider.lastName}`,
      })}
      modalDesktopWidth="desktop:max-w-[600px]"
    >
      <div className="desktop:max-h-[600px] overflow-y-auto scrollbar-thin scrollbar-thumb-rounded-full scrollbar-track-rounded-full">
        {messages.reverse().map(([day, messages]) => (
          <GroupByDayMessages
            provider={conversation?.patient}
            patient={conversation?.provider}
            messages={messages}
            day={day}
            key={day}
          />
        ))}
      </div>
    </Modal>
  );
};
